import { makeAutoObservable } from 'mobx'
import { CustomTableCollapsibleDetailConfig } from './CustomTable'

export class CustomTableLocalRow<RowData extends AnyObject, RowStore> {
   tableRowId
   row
   selected = false
   collapsibleOpen?
   collapsibleConfig
   rowStore: RowStore

   constructor(sp: {
      id: number,
      row: RowData,
      collapsibleConfig?: CustomTableCollapsibleDetailConfig<RowData>,
      rowStore?: RowStore
   }) {
      this.tableRowId = sp.id
      this.row = sp.row
      this.collapsibleConfig = sp.collapsibleConfig || {}
      this.rowStore = sp.rowStore ?? ({} as any)
      if (this.collapsibleConfig.rowHasCollapsibleDetail) {
         this.collapsibleOpen =
            this.collapsibleConfig.rowStartsOpened !== undefined
               ? this.collapsibleConfig.rowStartsOpened
               : false
      }
      makeAutoObservable(this)
   }

}
